module.exports = __webpack_public_path__ + "static/media/lambda.ef29fa6b.jpg";